<template>
    <body>
    <div class="container">
        <section class="hero">
            <h1>🎯 Поддержи развитие ИТ-кластера — получи расширенный доступ</h1>
            <p>
                <b>ИТ-кластер</b> — это пространство для общения собственников и руководителей сервисных ИТ-компаний, собранное вручную и без спама за три года активной работы. Чтобы оно продолжало развиваться — мы запускаем расширенный формат участия.
            </p>
        </section>

        <hr style="border: 1px solid lightgray">

        <section class="basic-access">
            <h2>🚀 Базовое участие — как и раньше, бесплатно</h2>
            <ul>
                <li>🟢 До двух представителей от одной компании в C-level чате</li>
                <li>🟢 Доступ к базовым функциям личного кабинета</li>
                <li>🟢 Участие в вебинарах</li>
                <li>🟢 Все как было — ничего не меняется</li>
            </ul>
        </section>

        <hr style="border: 1px solid lightgray">

        <section class="extended-access">
            <h2>✳️ Расширенные возможности</h2>
            <p>Вы можете подключить <b>опциональную подписку</b>, если вам нужно чуть больше, чем базовый доступ.</p>
            <h3><b>Статус «Партнер ИТ-кластера»</b></h3>
            <p>Расширенный доступ и дополнительные возможности:</p>
            <ul>
                <li>✅ +1 участник от компании в C-level чате</li>
                <li>✅ Упоминание компании в списке партнеров на главной странице сайта</li>
                <li>✅ Участие в закрытых опросах и обсуждениях тем</li>
                <li>✅ Возможность подробнее рассказать о своей компании в C-level чате</li>
                <li>✅ Полный доступ ко всем существующим и запланированным возможностям ЛК</li>
                <li>✅ Возможность выступить на оффлайн-мероприятии</li>
            </ul>
        </section>

        <hr style="border: 1px solid lightgray">

        <section class="why-support">
            <h2>Зачем это нужно?</h2>
            <p>Это позволит:</p>
            <ul>
                <li>Поддерживать сообщество без спама и рекламы</li>
                <li>Продолжать собирать аналитику по рынку, стекам, ставкам</li>
                <li>Делать вебинары, приглашать экспертов</li>
                <li>Сохранять независимость и качество</li>
            </ul>
        </section>

        <section class="active-participation">
            <h2>🤝 Поддержи ИТ-кластер участием</h2>
            <p>
                Не хочешь платить — но хочешь, чтобы сообщество жило, росло и развивалось?
            </p>
            <p>
                Супер! Есть <b>роль активного участника</b>, который помогает сообществу делом, не деньгами.
            </p>
            <p>
                Вот чем ты можешь быть полезен:
            </p>
            <ul>
                <li>🗞 Вести дайджест обсуждений в C-level чате</li>
                <p>— 1 раз в неделю делать краткий обзор: что обсуждали, какие инсайты, что стоит перечитать</p>
                <li>📅 Добавлять конференции и митапы в раздел мероприятий</li>
                <p>— отслеживать профильные офлайн- и онлайн-мероприятия для ИТ-бизнеса</p>
                <li>📊 Вести статистику по спросу на аутстафф</li>
                <p>— анализировать партнерки и собирать аналитику: какие технологии, грейды, ставки</p>
                <li>🤖 Помочь с автоматизациями на Telegram API</li>
                <p>— боты, авто-дайджесты, напоминания, аналитика по чатам и т. д.</p>
            </ul>
        </section>

        <section class="community-support">
            <h2>🌱 Поддержи индустрию заказной разработки</h2>
            <p>
                ИТ-кластер — это не просто чат. Это уникальное сообщество тех, кто строит рынок кастомной ИТ-разработки в России.
            </p>
            <p>Участие в ИТ-кластере — это вклад в:</p>
            <ul>
                <li>🧠 Формирование отраслевых стандартов:</li>
                <p> как предоставлять услуги, как удерживать команду, как работать с T&M</p>
                <li>🤝 Партнерскую экосистему между аутсорсерами</li>
                <p>где компании не конкуренты, а поставщики друг другу</p>
                <li>📢 Голос индустрии, не связанный с госструктурами</li>
                <p>независимая площадка, созданная руками таких же руководителей</p>
                <li>🛠 Рынок без спама и гуру — с реальной экспертизой</li>
                <p>где участники делятся опытом, а не курсами</p>
            </ul>
            <p>Поддерживая сообщество, вы поддерживаете свободный и зрелый рынок B2B-разработки, где бизнес говорит сам с собой, а не через посредников.</p>
        </section>

        <hr style="border: 1px solid lightgray">

        <section class="IT-claster">
            <h2>ИТ-кластер — это сила, которая формирует облик индустрии снизу вверх. Наша цель — не продавать доступ, а чтобы каждый собственник ИТ-компании мог сказать:</h2>
            <p>«Я тоже строю индустрию заказной разработки — вместе с ИТ-кластером ARDA»</p>
        </section>

        <hr style="border: 1px solid lightgray">

        <section class="stay-basic">
            <h2>💬 Остаетесь в «базе»? Почти ничего не меняется</h2>
            <p>
                Сообщество остается бесплатным — для всех, кому достаточно базового участия. Мы ценим ваш вклад, участие и помощь друг другу. Появится ограничение на часть функциональных возможностей личного кабинета.
            </p>
            <hr class="hr-business-first">
            <p class="p-business">
                Вы бизнесмены — и понимаете, что любой проект требует ресурсов. ИТ-кластер останется «своим» местом. Просто теперь у вас есть возможность поддержать сообщество — и получить немного больше.
            </p>
            <hr class="hr-business-second">
        </section>

        <section class="subscribe-button">
            <EnterButton @click="$router.push('/account/subscribe/')">Оформить подписку</EnterButton>
        </section>
    </div>
</body>
</template>

<script>
import EnterButton from '../Enter/Button.vue';
export default {
    name: "NewHomePage",
    components: { EnterButton }
};
</script>

<style scoped>
body {
    font-family: Arial, sans-serif;
    font-size: 18px;
    line-height: 1.6;
    margin: 0;
    padding: 0;
    color: #333;
    background-color: #f9f9f9;
}

.container {
    max-width: 1000px;
    margin: 0 auto;
    padding: 120px;
    background: #fff;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

hr {
    margin-top: 20px;
}

.hr-business-first {
    margin-top: 20px;
    margin-bottom: 5px;
    border: 1px solid lightgray
}

.hr-business-second {
    margin-top: 5px;
    margin-bottom: 50px;
    border: 1px solid lightgray
}

.hero h1 {
    font-size: 1.8em;
    font-weight: 900;
    margin-bottom: 10px;
}

.extended-access h2,
.why-support h2,
.active-participation h2,
.community-support h2,
.stay-basic h2 {
    font-size: 1.5em;
    font-weight: 900;
    margin-top: 20px;
    margin-bottom: 10px;
    color: #333;
}

.basic-access h2 {
    font-size: 1.2em;
    font-weight: 900;
    margin-top: 20px;
    margin-bottom: 10px;
    color: #333;
}

.extended-access h3 {
    margin: 15px 0;
    font-size: 1.3em;
    font-weight: 900;
}

.extended-access p {
    margin-bottom: 15px;
}

.why-support ul li::before {
    background-color: black;
}

.why-support ul li {
    padding-left: 20px;
}

.why-support ul {
    padding-left: 20px;
}

.why-support p {
    margin-bottom: 15px;
}

.active-participation ul li {
    margin: 15px 0;
    font-weight: 900;
}

.active-participation p {
    margin: 10px 0;
}

.community-support p {
    margin: 15px 0;
}

.IT-claster h2 {
    margin-top: 20px;
}

.IT-claster p {
    font-weight: 900;
    margin: 15px 10px 30px 15px;
}

.p-business {
    margin-left: 20px;
}

ul {
    list-style: none;
    padding: 0;
}

ul li {
    margin-bottom: 8px;
    position: relative;
}

ul li::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 10px;
    height: 10px;
    border-radius: 50%;
}

.subscribe-button button {
    display: block;
    width: 100%;
}

</style>